import sha256 from 'js-sha256';

const maxHashLength = 50;
const getHashedUserId = (userAccount) => {
  if (!userAccount?.id) return 'Unknown-ID';

  let hashedAccount = sha256(userAccount.id);
  if (hashedAccount.length > maxHashLength) {
    hashedAccount = hashedAccount.slice(0, maxHashLength);
  }

  return hashedAccount;
}

export default getHashedUserId;